import React from 'react';
import PropTypes from 'prop-types';

const DeletePopup = ({
    open = true,
    title,
    description,
    onConfirm,
    onCancel,
    confirmLabel = "Yes, I'm sure",
    cancelLabel = 'No',
}) => {
    if (!open) return null;
    return (
        <div className="popup">
            <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center z-[8] sm:p-0">
                        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[395px] ">
                            <div className="bg-white px-4  sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <div className="mt-3 text-center mx-auto sm:mt-0 ">
                                        <div className="mt-1">
                                            <p className="text-base text-gray-700 font-google font-normal">
                                                {title}
                                            </p>
                                            {description && (
                                                <p className="text-base text-gray-700 font-google font-normal">
                                                    {description}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="bg-white px-4 pb-3 flex gap-2 items-center justify-center sm:px-6">
                                <button
                                    type="button"
                                    className="inline-flex justify-center rounded bg-[#42B4F4] px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#42B4F4] border-0 font-google"
                                    onClick={onConfirm}
                                >
                                    {confirmLabel}
                                </button>
                                <button
                                    type="button"
                                    className="inline-flex justify-center rounded bg-white px-6 py-2 text-sm font-semibold text-gray-900 shadow-sm border border-gray-300 hover:bg-gray-50 font-google"
                                    onClick={onCancel}
                                >
                                    {cancelLabel}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

DeletePopup.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
};

export default DeletePopup; 